// api
import { fetchApi } from '@/api'
// actions
const cafeteriaReportsAll = (context) => {
  let url = 'cafeteria/reports'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportsForm = (context) => {
  let url = 'cafeteria/reports/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportsShow = (context) => {
  let url = 'cafeteria/reports'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const cafeteriaReportsCreate = (context) => {
  let url = 'cafeteria/reports/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportsUpdate = (context) => {
  let url = 'cafeteria/reports'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('CAFETERIA_REPORTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportsDelete = (context, payload) => {
  let url = 'cafeteria/reports'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('CAFETERIA_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
const cafeteriaReportsDataUser = (context, array) => {
  let url = 'cafeteria/datauser'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportslistRVD = (context, array) => {
  let url = 'cafeteria/reporteRVD'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportslistRVDP = (context, array) => {
  let url = 'cafeteria/reporteRVDP'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportslistReversion = (context, array) => {
  let url = 'cafeteria/reporteReversion'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const CafeteriarevertirCobro = (context, array) => {
  let url = 'cafeteria/reporteRevDelete'
  return fetchApi(url, array, 'POST')
    .then((response) => {
      context.commit('CAFETERIA_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaReportslistRM = (context, array) => {
  let url = 'cafeteria/reporteRM'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REPORTS_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  cafeteriaReportsAll,
  cafeteriaReportsForm,
  cafeteriaReportsShow,
  cafeteriaReportsCreate,
  cafeteriaReportsUpdate,
  cafeteriaReportsDelete,
  cafeteriaReportsDataUser,
  cafeteriaReportslistRVD,
  cafeteriaReportslistRVDP,
  cafeteriaReportslistReversion,
  CafeteriarevertirCobro,
  cafeteriaReportslistRM
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/reports/actions.js